import React, { Component } from 'react';
import { connect } from 'react-redux';
import {  Card, CardBody, Col, Container, Row } from 'reactstrap';
import { confirmCheckout } from '../store/actions/paymentActions';

class Confirmation extends Component {
	constructor(props){
		super(props);
		if(this.props.match.params.id && this.props.location.search){
			this.props.confirmCheckout(this.props.match.params.id,this.props.location.search.substring(1))
		}
	}
	
	render(){
		var response = this.props.json_lang.http_codes.general_success
		var responseColor = 'text-success'

		if(this.props.paymentResponse && this.props.paymentResponse.message){
			response = this.props.json_lang.http_codes[this.props.paymentResponse && this.props.paymentResponse.message]
			responseColor = 'text-danger'
		}
		return (
			<div className="app flex-row align-items-center custom_bg" >
				<Container>
					<Row className="justify-content-center">
						<Col md="6">
							<Card className="p-4">
								<CardBody>
									<h1 className={ responseColor }>{response}</h1>
								</CardBody>
							</Card>
						</Col>		
					</Row>
				</Container>
			</div>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		company:state.company,
		json_lang: state.json_lang,
		paymentResponse:state.paymentResponse
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		confirmCheckout: (id,qs) => dispatch(confirmCheckout(id,qs)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(Confirmation);


// WEBPACK FOOTER //
// ./src/views/checkout.js